﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import type { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";
import type { JssClass } from "~base/Styling";
import { getSize } from "~base/Components/Layout/JssSpacing";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export interface ReactComponentClasses {
    header: string;
}

export interface ReactComponentStyles {
    header: JssClass;
}

export const useAdditionalStyles = createUseStyles(
    (theme: ConsilioBaseTheme): ReactComponentStyles => {
        const styles = {
            header: {
                padding: `25px ${25 + getSize("HalfMedium")}px 0px ${25 + getSize("HalfMedium")}px`,
            },
        };

        return styles;
    }
);
